"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOrder = void 0;
function parseOrder(order) {
    return Object.assign(Object.assign({}, order), { date: new Date(order.date) });
}
exports.parseOrder = parseOrder;
